module.exports = __webpack_public_path__ + "img/HC1021-160.58b3bf03.jpg";